module.exports = __webpack_public_path__ + "files/f360fc5a5b6fa0637f8f84f2ca9cf5ae.png";